"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncateToDecimals = exports.replaceZeroWithDash = exports.parseNumberToLocale = exports.init = exports.getParsedDecimal = exports.getLocaleSettings = exports.formatToThousands = exports.formatPercentageValue = exports.formatNumberToLocale = exports.currency = void 0;
var _bignumber = require("bignumber.js");
var _parseNumber = require("./parseNumber");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var makeBigNumber = function makeBigNumber(value) {
  return new _bignumber.BigNumber(isNaN(value) ? 0 : value);
};
var NumberFormatter = /*#__PURE__*/function () {
  function NumberFormatter() {
    _classCallCheck(this, NumberFormatter);
    this.locale = null;
    this.delimiters = null;
    this.getDecimalPlaces = null;
  }

  /**
   * @param {Object} options
   * @param {String} options.locale
   * @param {Function} options.getDecimalPlaces
   */
  return _createClass(NumberFormatter, [{
    key: "init",
    value: function init(options) {
      this.locale = options.locale;
      this.getDecimalPlaces = options.getDecimalPlaces;
      this.delimiters = this.getLocaleSettings();
      _bignumber.BigNumber.config({
        ROUNDING_MODE: options.roundingMode ? options.roundingMode : _bignumber.BigNumber.ROUND_FLOOR,
        FORMAT: {
          decimalSeparator: this.delimiters.decimal,
          groupSeparator: this.delimiters.thousands,
          groupSize: 3
        }
      });
    }
  }, {
    key: "currency",
    value: function currency(value, symbol) {
      var currency = makeBigNumber(value);
      currency.symbol = symbol;
      return currency;
    }
  }, {
    key: "formatPercentageValue",
    value: function formatPercentageValue(value) {
      var number = makeBigNumber(value);
      return "".concat(number.toFormat(2), "%");
    }
  }, {
    key: "formatToThousands",
    value: function formatToThousands(value) {
      return Number(value).toLocaleString(undefined, {
        notation: 'compact',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    /**
     * Formats a number to a locale-specific string
     * @param {string|number|BigNumber} value Value to format
     * @param {string|number} symbolOrDecimals Either number of decimals or currency symbol to use for formatting
     * @param {{ removeTrailingZeroes: boolean; roundingMode?: BigNumber.RoundingMode }} [options] Optional formatting options
     * @returns {string} Formatted number
     */
  }, {
    key: "formatNumberToLocale",
    value: function formatNumberToLocale(value, symbolOrDecimals) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        removeTrailingZeroes: false
      };
      var num = makeBigNumber(value);
      var decimals;
      if (typeof symbolOrDecimals === 'string') {
        var decimalPlaces = this.getDecimalPlaces();
        decimals = decimalPlaces[symbolOrDecimals];
      } else {
        decimals = symbolOrDecimals;
      }
      if (options.removeTrailingZeroes) return num.decimalPlaces(decimals).toString();
      if (options.roundingMode) return num.toFormat(decimals, _bignumber.BigNumber[options.roundingMode]);
      return num.toFormat(decimals);
    }
  }, {
    key: "parseNumberToLocale",
    value: function parseNumberToLocale(value, localeOverride) {
      var negativeIsNaN = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var delimiters = this.getLocaleSettings(localeOverride);
      var cleanedValue = (0, _parseNumber.cleanFormattedString)(value.toString(), delimiters);
      if (cleanedValue === null) return NaN;
      var parsed = (0, _parseNumber.parseNumber)(cleanedValue);
      return negativeIsNaN && parsed < 0 ? NaN : parsed;
    }
  }, {
    key: "replaceZeroWithDash",
    value: function replaceZeroWithDash(value) {
      return value === 0 ? '-' : value;
    }
  }, {
    key: "truncateToDecimals",
    value: function truncateToDecimals(value, decimalPlaces) {
      var roundingMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var number = makeBigNumber(value);
      return number.decimalPlaces(decimalPlaces, roundingMode);
    }
  }, {
    key: "getParsedDecimal",
    value: function getParsedDecimal(value, decimalPlaces) {
      var localeOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      // returns an object useful for complex rendering of decimal values
      var _ref = localeOverride ? this.getLocaleSettings(localeOverride) : this.delimiters,
        thousands = _ref.thousands,
        decimal = _ref.decimal;
      var BN = localeOverride ? _bignumber.BigNumber.clone({
        FORMAT: {
          decimalSeparator: decimal,
          groupSeparator: thousands,
          groupSize: 3
        }
      }) : _bignumber.BigNumber;
      var bigNum = new BN(isNaN(value) ? 0 : value);
      var parts = bigNum.toFormat().split(decimal);
      var units = parts[0];
      var decimals = parts.length > 1 && parts[1].length ? parts[1] : '0';
      if (decimals.length > decimalPlaces) {
        // concat
        decimals = decimals.substr(0, decimalPlaces);
      }
      var padding = decimals.length < decimalPlaces ? '0'.repeat(decimalPlaces - decimals.length) : '';
      return {
        negative: bigNum.isNegative(),
        units: units,
        decimalSeparator: decimal,
        decimals: decimals,
        padding: padding
      };
    }

    /**
     * Retrieves the decimal and thousands separators for the specified locale
     * @param {string} [localeOverride] Locale to use for settings retrieval. If not provided, the default locale is used.
     * @returns {{ decimal: string; thousands: string }} Separators based on the locale
     */
  }, {
    key: "getLocaleSettings",
    value: function getLocaleSettings() {
      var localeOverride = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // A number with both decimal and thousand separators
      var number = 1234567.89;

      // Create a formatter for the specified locale
      var formatter = new Intl.NumberFormat(localeOverride || this.locale);

      // Format the number into parts
      var parts = formatter.formatToParts(number);

      // Initialize variables to store separators
      var settings = {
        decimal: '',
        thousands: ''
      };

      // Iterate over the parts to find the separators
      var _iterator = _createForOfIteratorHelper(parts),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var part = _step.value;
          if (part.type === 'decimal') {
            settings.decimal = part.value;
          } else if (part.type === 'group') {
            settings.thousands = part.value;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return settings;
    }
  }]);
}();
var numberFormatter = new NumberFormatter();
var init = exports.init = numberFormatter.init.bind(numberFormatter);
var currency = exports.currency = numberFormatter.currency.bind(numberFormatter);
var formatPercentageValue = exports.formatPercentageValue = numberFormatter.formatPercentageValue.bind(numberFormatter);
var formatToThousands = exports.formatToThousands = numberFormatter.formatToThousands.bind(numberFormatter);
/**
 * Formats a number to a locale-specific string
 * @param {string|number|BigNumber} value Value to format
 * @param {string|number} symbolOrDecimals Either number of decimals or currency symbol to use for formatting
 * @param {{ removeTrailingZeroes: boolean; roundingMode?: BigNumber.RoundingMode }} [options] Optional formatting options
 * @returns {string} Formatted number
 */
var formatNumberToLocale = exports.formatNumberToLocale = numberFormatter.formatNumberToLocale.bind(numberFormatter);
var parseNumberToLocale = exports.parseNumberToLocale = numberFormatter.parseNumberToLocale.bind(numberFormatter);
var replaceZeroWithDash = exports.replaceZeroWithDash = numberFormatter.replaceZeroWithDash.bind(numberFormatter);
var truncateToDecimals = exports.truncateToDecimals = numberFormatter.truncateToDecimals.bind(numberFormatter);
var getParsedDecimal = exports.getParsedDecimal = numberFormatter.getParsedDecimal.bind(numberFormatter);
/**
 * Retrieves the decimal and thousands separators for the specified locale
 * @param {string} [localeOverride] Locale to use for settings retrieval. If not provided, the default locale is used.
 * @returns {{ decimal: string; thousands: string }} Separators based on the locale
 */
var getLocaleSettings = exports.getLocaleSettings = numberFormatter.getLocaleSettings.bind(numberFormatter);